<template>
    <CardPage :section="section" :page="page" :backOverrideFunction="backClick" ref="cardPage">
        <v-fade-transition hide-on-leave>
            <div v-if="!modifyGoals">
                <p>
                    <slot></slot>
                </p>
                <comp-4-goals-display></comp-4-goals-display>
                <p>Do you want to make any changes to your goals?</p>
            </div>
        </v-fade-transition>
        <v-fade-transition hide-on-leave>
            <div v-if="modifyGoals">
                <comp-4-goals></comp-4-goals>
            </div>
        </v-fade-transition>
        <template v-if="modifyGoals" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round large color="primary" @click="save" :disabled="myGoalsInvalid">Save</v-btn>
            <v-spacer></v-spacer>
        </template>
        <template v-else v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round large color="primary" @click="modifyGoals = true">Yes</v-btn>
            <v-btn round large color="primary" @click="next">No</v-btn>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            modifyGoals: false
        };
    },
    props: {
        section: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        }
    },
    computed: {
        goal1category: get('section4/myGoals@1.category'),
        goal1text: get('section4/myGoals@1.text'),
        goal1shown: get('section4/myGoals@1.shown'),
        goal2category: get('section4/myGoals@2.category'),
        goal2text: get('section4/myGoals@2.text'),
        goal2shown: get('section4/myGoals@2.shown'),
        goal3category: get('section4/myGoals@3.category'),
        goal3text: get('section4/myGoals@3.text'),
        goal3shown: get('section4/myGoals@3.shown'),
        goal4category: get('section4/myGoals@4.category'),
        goal4text: get('section4/myGoals@4.text'),
        goal4shown: get('section4/myGoals@4.shown'),
        myGoalsInvalid: get('section4/myGoalsInvalid')
    },
    methods: {
        backClick() {
            if (this.modifyGoals) {
                this.modifyGoals = false;
            } else {
                router.back();
            }
        },
        next() {
            this.$refs.cardPage.nextClick();
        },
        save() {
            this.modifyGoals = false;
            this.next();
        }
    }
};
</script>
